import * as Sentry from "@sentry/react";

/**
 * Logs an error to the console and reports it to Sentry.
 * Drop-in replacement for console.error in catch blocks.
 */
export function captureError(
    message: string,
    error: unknown,
    tags?: Record<string, string>,
): void {
    console.error(message, error);
    Sentry.captureException(error instanceof Error ? error : new Error(String(error)), {
        extra: { message },
        tags,
    });
}
